<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/weier/process/plan/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuadanhao')">
        <el-input v-model="yt.conditions.no"></el-input>
      </el-form-item>
      <el-form-item :label="$t('kehudingdanhao')">
        <el-input v-model="yt.conditions.customerOrderNo"></el-input>
      </el-form-item>
      <el-form-item :label="$t('zuzhuanghao')">
        <el-input v-model="yt.conditions.asmNo"></el-input>
      </el-form-item>
      <el-form-item :label="$t('xuqianjiagong')">
        <el-select v-model="yt.conditions.preProcessFlag">
          <el-option :label="$t('shi')" :value="true"></el-option>
          <el-option :label="$t('fou')" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('ERPgongdanhao')">
        <el-input v-model="yt.conditions.erpNo"></el-input>
      </el-form-item>
      <el-form-item :label="$t('chanpinbianma')">
        <el-input v-model="yt.conditions.materialCode"></el-input>
      </el-form-item>
      <el-form-item :label="$t('chanpinmingcheng')">
        <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
      </el-form-item>
      <el-form-item :label="$t('guishuchejian')">
        <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
      </el-form-item>
      <el-form-item :label="$t('zhuangtai')">
        <el-select v-model="yt.conditions.status">
          <el-option :label="$t('daipaichan')" :value="1"></el-option>
          <el-option :label="$t('yipaichan')" :value="2"></el-option>
          <el-option :label="$t('guanbi')" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('shifouwangong')">
        <el-select v-model="yt.conditions.completed">
          <el-option :label="$t('shi')" :value="1"></el-option>
          <el-option :label="$t('fou')" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
        <el-input v-model="yt.conditions.erpRequireSourceNo"></el-input>
      </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ manufacturingProcess: '03'})">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #shifouwangong="scope">
        <el-tag :type="scope.row.completed ? 'success' : 'warning'" size="mini">
          {{ scope.row.completed ? $t('shi') : $t('fou') }}
        </el-tag>
      </template>
      <template #xuqianjiagong="scope">
        <el-tag :type="scope.row.preProcessFlag ? 'success' : 'warning'" size="mini">
          {{ scope.row.preProcessFlag ? $t('shi') : $t('fou') }}
        </el-tag>
      </template>
    		<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'600px');getPageAssemble();yt.editObj.manufacturingProcess='03' " type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template>

      <template #zhuangtai="scope">
        <el-tag :type="scope.row.status === 2 ? 'success' : scope.row.status === 3 ? 'danger' : 'warning'" size="mini">
          {{ $t(store.state.dictJsonAll['PRODUCTION_PLAN_STATUS'][scope.row.status]) }}
        </el-tag> </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('paichan', scope.row, 'w1');getProcessEquipmentList();beforeShowPaichan();" v-if="utils.checkPower('web_screen_printing_management_production_plan_schedulingSilkScreen') && scope.row.status == 1" >{{ $t('paichan') }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_screen_printing_management_production_plan_create')" type="text" @click="yt.showEditDialog('jihuadanbom', scope.row, 'w2')">
              {{ $t('jihuadanbom') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_screen_printing_management_production_plan_update') && (scope.row.children || scope.row.parentId == null)">
            <el-button
              v-if="scope.row.status == 1"
              type="text"
              @click="
                yt.showEditDialog('bianji', scope.row, 'w2', beforeShowEditDialog);
              "
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="store.state.global_loading"
                       v-if="utils.checkPower('web_screen_printing_management_production_plan_delete') && scope.row.schedulingQuantity == 0"
                       type="text" class="font-color-danger"
                       @click="yt.remove(scope.row, '/custom/weier/process/plan/delete')">{{ $t('shanchu') }} </el-button>
					</el-col>
          <el-col :span="0.1">
            <el-button
              v-if="utils.checkPower('web_screen_printing_management_production_plan_close') && scope.row.status == 1"
              type="text"
              @click="colseForm( scope.row)">
              {{ $t('guanbi') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
     <!-- 新增/编辑弹框 -->
     <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
         <!-- 新增表单 -->
         <template v-if="yt.editObj.action == 'xinzeng'">
          <div class="dialog-scroller">
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
              <el-form-item :label="$t('jihuadanhao')" required>
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <!-- 下拉框 -->
            <!-- <yi_data_select :max="1" :type="'material2'" :ids.sync="yt.editObj.materialId"> </yi_data_select> -->
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1" :ids.sync="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('kehudingdanhao')" required>
              <el-input v-model="yt.editObj.customerOrderNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zuzhuanghao')" >
              <el-input v-model="yt.editObj.asmNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zuzhuangpeibi')" >
              <el-input-number v-model="yt.editObj.ratio" :precision="0" :step="1" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('xuqianjiagong')">
              <el-select v-model="yt.editObj.preProcessFlag">
                <el-option :label="$t('shi')" :value="1"></el-option>
                <el-option :label="$t('fou')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input :maxTime="91 * 24 * 3600 * 1000" type="daterange" :start.sync="yt.editObj.startTime" :end.sync="yt.editObj.endTime"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.editObj.erpNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
              <el-input v-model="yt.editObj.erpRequireSourceNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/custom/weier/process/plan/create')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
         </template>
       <!-- 编辑表单 -->
       <template v-if="yt.editObj.action == 'bianji'">
         <div class="dialog-scroller">
           <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
             <!-- 不可编辑  -->
             <el-form-item :label="$t('jihuadanhao')" required>
               <el-input v-model="yt.editObj.no" disabled="true"></el-input>
             </el-form-item>
             <el-form-item :label="$t('guishuchejian')" required>
               <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
             </el-form-item>
             <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
               <!-- 下拉框 -->
               <!-- <yi_data_select :max="1" :type="'material2'" :ids.sync="yt.editObj.materialId"> </yi_data_select> -->
               <yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1" :ids.sync="yt.editObj.materialId"></yi_cross_select>
             </el-form-item>
             <el-form-item :label="$t('kehudingdanhao')" required>
               <el-input v-model="yt.editObj.customerOrderNo"></el-input>
             </el-form-item>
             <el-form-item :label="$t('zuzhuanghao')" >
               <el-input v-model="yt.editObj.asmNo"></el-input>
             </el-form-item>
             <el-form-item :label="$t('zuzhuangpeibi')" >
               <el-input-number v-model="yt.editObj.ratio" :precision="0" :step="1" :min="1"></el-input-number>
             </el-form-item>
             <el-form-item :label="$t('xuqianjiagong')">
               <el-select v-model="yt.editObj.preProcessFlag">
                 <el-option :label="$t('shi')" :value="1"></el-option>
                 <el-option :label="$t('fou')" :value="0"></el-option>
               </el-select>
             </el-form-item>
             <el-form-item :label="$t('jihuashuliang')" required>
               <el-input v-model="yt.editObj.quantity"></el-input>
             </el-form-item>
             <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
               <yi_time_input :maxTime="91 * 24 * 3600 * 1000" type="daterange" :start.sync="yt.editObj.startTime" :end.sync="yt.editObj.endTime"> </yi_time_input>
             </el-form-item>
             <el-form-item :label="$t('ERPgongdanhao')">
               <el-input v-model="yt.editObj.erpNo"></el-input>
             </el-form-item>
             <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
               <el-input v-model="yt.editObj.erpRequireSourceNo"></el-input>
             </el-form-item>
             <el-form-item :label="$t('beizhu')">
               <el-input v-model="yt.editObj.remark"></el-input>
             </el-form-item>
           </el-form>
         </div>
         <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/custom/weier/process/plan/update')"
                     type="primary">{{$t('baocun')}}
					</el-button>
				</span>
       </template>

       <!-- 排产表单 -->
         <template v-if="yt.editObj.action == 'paichan'">
          <div class="dialog-scroller">
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
              <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
                <yi_cross_select disabled :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1" :ids.sync="yt.editObj.materialId"></yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('chanxian')" required>
              <el-select v-model="yt.editObj.equipmentId" @change="getItems">
                <el-option style="width: 350px" v-for="(item,index) in productionList" :label="item.labelName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('kepaichanshuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="scheduling"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bencijihuashuliang')" required>
              <el-input-number v-model="yt.editObj.curQuantity" :precision="0" :disabled="yt.editObj.equipmentId === undefined || yt.editObj.equipmentId === ''" :max="maxValue" @input="changePlanNumber" />
            </el-form-item>
            <el-form-item :label="$t('jihuakaishishijian')" required>
              <yi_time_input :disabled="yt.editObj.equipmentId === undefined || yt.editObj.equipmentId === ''" :minMaxBase="'current'" type="datetime" :time.sync="yt.editObj.startTime" @update:time="changeStartTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuawanchengshijian')" required>
              <yi_time_input :disabled="yt.editObj.equipmentId === undefined || yt.editObj.equipmentId === ''" type="datetime" :time.sync="yt.editObj.endTime" @update:time="changeEndTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('gongdanshunxu')" required>
              <el-input type="number" @input="onInput()" oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')" v-model="yt.editObj.priority"></el-input>
            </el-form-item>
<!--            <el-form-item :label="$t('shijimoqiangshu')" required="required" label-width="145px">
              <el-input-number v-model="yt.editObj.actualCavity" controls-position="right" :min="1"></el-input-number>
            </el-form-item>-->
            <el-form-item :label="$t('gongyiluxianbianma/mingcheng')" required>
              <yi_data_select type="craft" :ids.sync="yt.editObj.craftId"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="utils.checkPower('web_screen_printing_management_production_plan_schedulingSilkScreen')" :loading="yt.editObj.loading" size="mini" @click="getScheduling(yt.editObj)" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button size="mini" v-if="utils.checkPower('web_screen_printing_management_production_plan_schedulingAndGiveOutSilkScreen')" :loading="yt.editObj.loading" @click="getSchedulingAndGiveOut(yt.editObj)" type="primary">
            {{ $t('baocunbingpaichanfafang') }}
          </el-button>
          <el-button size="mini" v-if="utils.checkPower('web_screen_printing_management_production_plan_getBomStock')" :loading="yt.editObj.loading"  @click="showKuncunDialog(yt.editObj);" type="primary">
            {{ $t('bomkucunchaxun') }}
          </el-button>
        </span>
         </template>
         <template v-if="yt.editObj.action == 'jihuadanbom'">
        <div class="dialog-scroller">
          <bom :bomWork="yt.editObj"></bom>
        </div>
      </template>
    </el-dialog>
    <!-- 库存弹窗 -->
      <el-dialog :show-close="true" :title="$t('bomkucunchaxun')" :visible.sync="isShowKucunEditDialog" :width="'80%'" :close-on-click-modal="false" append-to-body="append-to-body">
        <div class="dialog-scroller">
          <bomInventory v-if="isShowKucunEditDialog" :bomWork="showKucunObj"></bomInventory>
        </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
  import bom from '@@/pages/web/customize/weier/screen_printing_management/production_plan/bom';
  import bomInventory from '@@/pages/web/customize/weier/screen_printing_management/production_plan/bom_inventory';
export default {
  name: 'web_silk_screen_order_management_list',
  components: {
    bom,
    bomInventory
  },
  data() {
    return {
      isShowKucunEditDialog:false,
      showKucunObj: {},
      pageAssembleList:[],
      productionList:[],
      scheduling: 0,
      actualCavity: '',
      cavity: '',
      cycle: '',
      creaftId: '',
      //用于打断计划数量、计划开始时间、计划完成时间计算循环
      changeSourse: '',
      columns: [
        {
          label: 'jihuadanhao',
          prop: 'no',
          sort: 'string',
          width: 130
        },
        {
          label: 'kehudingdanhao',
          prop: 'customerOrderNo',
          sort: 'string',
          width: 160
        },
        {
          label: 'zuzhuanghao',
          prop: 'asmNo',
          sort: 'string',
          width: 100
        },
        {
          label: 'zuzhuangpeibi',
          prop: 'ratio',
          sort: 'number',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 160
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 160
        },
        {
          label: 'guige',
          prop: 'material.spec',
          sort: 'string',
          width: 130
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: false
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient',
          sort: 'string',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'quantity'
        },
        {
          label: 'yipaichanshuliang',
          prop: 'schedulingQuantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'leftProductionQuantity',
          width: 130
        },
        {
          label: 'chaochanshuliang',
          prop: 'overProductionQuantity',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name',
          width: 120
        },
        {
          label: 'zhuangtai',
          type: 'slot',
          prop: 'status'
        },
        {
          label: 'shifouwangong',
          type: 'slot',
          prop: 'completed'
        },
        {
          label: 'xuqianjiagong',
          prop: 'preProcessFlag',
          type: 'slot',
          width: 150
        },
        {
          label: 'jihuakaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 160
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'endTime',
          type: 'time',
          width: 160
        },
        {
          label: 'huohao',
          prop: 'articleNumber',
          width: 150
        },
        {
          label: 'shengchandingdanfenluid',
          prop: 'orderEntryId',
          width: 150
        },
        {
          label: 'erpxuqiulaiyuandanhao',
          prop: 'erpRequireSourceNo',
          width: 140
        },
        {
          label: 'kehubianma',
          prop: 'customerCode',
          width: 130
        },
        {
          label: 'kehumingcheng',
          prop: 'customerName'
        },
        {
          label: 'kehuwuliaobianma',
          prop: 'customerMaterialCode',
          width: 130
        },
        {
          label: 'kehuwuliaomingcheng',
          prop: 'customerMaterialName',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 280,
          fixed: 'right'
        }
      ]
    };
  },
  computed: {
    maxValue() {
      return this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity;
    },
  },
  mounted() {

  },
  created() {
    setTimeout(() => {
      // this.yt.conditions = {
      //   no: this.$attrs.conditions.no,
      //   // customerId: this.$attrs.customerId,
      //   // orderBy: 'createTime desc',
      // }
      //丝印
      this.yt.conditions.manufacturingProcess="03";

      this.yt.get(1);
    }, 300);
    this.http.get('/web/craft/basic/process/route/page?pageNum=1&pageSize=999&isComponent=true').then((res) => {
      console.log('res', res)
      let items = res.data.rows;
      for(let i = 0; i < items.length; i++){
        if(items[i].code == '002'){
          this.creaftId = items[i].id;
        }
      }
    });
  },
  methods: {
    showKuncunDialog(obj){
      this.isShowKucunEditDialog = true;
      this.showKucunObj = obj;
    },
    onInput() {
      this.$forceUpdate();
    },
    /**
     * 查找默认模具及产品关系
     */
    getItems() {
      let params = {
        equipmentId: this.yt.editObj.equipmentId,
        materialId: this.yt.editObj.materialId,
      };
      this.http.get('/custom/weier/process/plan/getMouldEquipment', { params }).then((res) => {
        console.log('res', res)
        let items = res.data;
        this.cavity = items.cavity;
        this.cycle = items.cycle;
        this.actualCavity = items.actualCavity;
        if (this.actualCavity) {
          this.$set(this.yt.editObj, 'actualCavity', this.actualCavity);
          if (this.yt.editObj.children) {
            for (let i = 0; i < this.yt.editObj.children.length; i++) {
              this.$set(this.yt.editObj.children[i], 'actualCavity', this.actualCavity);
            }
          }
        }
      });
    },
    /**
     * 计划数量
     * @param value
     */
    changePlanNumber(value) {
      if(this.yt.editObj.startTime==null||this.yt.editObj.endTime==null){
      }else if(this.changeSourse!=null){
        return;
      }
      this.$set(this,'changeSourse','planNumber');
      // 计划完成时间=计划开始时间(时间戳)+本次计划数量*标准周期*1000/模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        if(this.materialPassRateShow){
          //如果合格率(%)不为空，计划完成时间=(计划数量/合格率(%))得出的数量取整， 根据 机模配 所需的生产时间 加上 计划开始时间
          let planQuantity = Math.floor(this.yt.editObj.curQuantity / (this.yt.editObj.material.passRate / 100));
          let endTime = this.yt.editObj.startTime + (planQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        } else {
          const endTime = this.yt.editObj.startTime + (this.yt.editObj.curQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        }
        setTimeout(() => {
          this.changeSourse = null;
        }, 300);
      }
    },
    /**
     * 计划开始时间
     * @param value
     */
    changeStartTime(value) {
      if(this.yt.editObj.curQuantity==null||this.yt.editObj.endTime==null){
      }else if(this.changeSourse!=null){
        return;
      }
      this.$set(this,'changeSourse','startTime');
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuakaishishijianbunengdayujiahuawanchengshijian'));
        this.yt.editObj.startTime = '';
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        // 计划完成时间=计划开始时间(时间戳)+本次计划数量*标准周期*1000/模穴数
        // 如果合格率(%)不为空，计划完成时间=(计划数量/合格率(%))得出的数量取整， 根据 机模配 所需的生产时间 加上 计划开始时间
        if (this.materialPassRateShow) {
          let planQuantity = Math.ceil(this.yt.editObj.curQuantity / (this.yt.editObj.material.passRate / 100));
          let endTime = this.yt.editObj.startTime + (planQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        } else {
          const endTime = this.yt.editObj.startTime + (this.yt.editObj.curQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        }
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        if (!this.materialPassRateShow || this.yt.editObj.material.passRate == 100) {
          const curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity;
          if(curQuantity != null && curQuantity > 0){
            this.$set(this.yt.editObj, 'curQuantity', curQuantity);
          }
        } else {
          let curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity * (this.yt.editObj.material.passRate / 100);
          if(curQuantity != null && curQuantity > 0){
            this.$set(this.yt.editObj, 'curQuantity', curQuantity);
          }
        }
      }
      setTimeout(() => {
        this.changeSourse = null;
      }, 300);
    },
    /**
     * 计划结束时间
     * @param value
     */
    changeEndTime(value) {
      if(this.yt.editObj.curQuantity==null||this.yt.editObj.endTime==null){
      }else if(this.changeSourse!=null){
        return;
      }
      this.$set(this,'changeSourse','endTime');
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuawanchengshijianbunengxiaoyujihuakaishishijian'));
        this.yt.editObj.endTime = '';
      }
      // 本次计划数量=(计划完成时间(时间戳)-计划开始时间(时间戳))/1000/标准周期*模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        if (!this.materialPassRateShow || this.yt.editObj.material.passRate == 100) {
          const curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity;
          if(curQuantity != null && curQuantity > 0){
            this.$set(this.yt.editObj, 'curQuantity', curQuantity);
          }
        } else {
          //如果合格率(%)不为空，计划完成时间=(计划数量/合格率(%))得出的数量取整， 根据 机模配 所需的生产时间 加上 计划开始时间
          let curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity * (this.yt.editObj.material.passRate / 100);
          if(curQuantity != null && curQuantity > 0){
            this.$set(this.yt.editObj, 'curQuantity', curQuantity);
          }
        }
      }
      setTimeout(() => {
        this.changeSourse = null;
      }, 300);
    },
    colseForm(val){
      console.log('bbbbbbbbbbbbbbbbbb',val)
      this.$confirm(this.$t('shiofouguanbi?'), this.$t('guanbiqueren'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
          this.getColse(val.id)
        })
        .catch(() => {});
    },
    getColse(id){
      let params = {
        id: id,
      };
      this.http.post('/custom/weier/process/plan/close',params).then((res) => {
        this.utils.successMessage(res.msg)
      }).catch((msg) => {
        this.utils.errorMessage(msg);
      });
    },
    // 原组装计划单
    getPageAssemble: function() {
      let params = {
        customerOrderNo: '12321',
        asmNo: '3213',
        isVirtual: false
      };
      this.http.get('/custom/weier/process/plan/pageAssemble', { params }).then((res) => {
        this.pageAssembleList = res.data.rows;
        for(let i=0;i<this.pageAssembleList.length;i++){
          const labelName = this.pageAssembleList[i]['customerOrderNo']+' | '+this.pageAssembleList[i]['erpRequireSourceNo']+' | '+this.pageAssembleList[i]['no']
          this.$set(this.pageAssembleList[i],'labelName',labelName)
        }
        // this.utils.successMessage(res.msg)
      }).catch((msg) => {
        this.utils.errorMessage(msg);
      });
    },
    getProcessEquipmentList(){
      this.http.get('/custom/weier/process/plan/getProcessEquipmentList').then((res) => {
        this.productionList = res.data;
        for(let i=0;i<this.productionList.length;i++){
          const labelName = this.productionList[i]['name']+' | '+this.productionList[i]['sn']
          this.$set(this.productionList[i],'labelName',labelName)
        }
        // this.utils.successMessage(res.msg)
      }).catch((msg) => {
        this.utils.errorMessage(msg);
      });
    },
    beforeShowPaichan(editObj) {
      this.scheduling = this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity;
      this.yt.editObj.priority = 1 ;
      this.yt.editObj.craftId = this.creaftId;
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'xinzeng' || editObj.action === 'zengjiafudan') {
        editObj.children = [
          {
            no: '',
            materialId: '',
            quantity: undefined,
            erpNo: '',
            remark: ''
          }
        ];
        if (editObj.action === 'zengjiafudan') {
          this.setParentId(editObj);
        }
      }
      return editObj;
    },
    //排产保存
    getScheduling(row) {
      this.yt.editObj.actualCavity = 1;
      this.objectList = row;
      this.recommendEquipment = null;
      this.disabled1 = true;
      this.yt.editObj.loading = true;
      // isCheckMouldStatus
      return this.http
        .post('/custom/weier/process/plan/schedulingSilkScreen', {
          ...row
        })
        .then(response => {
          console.log('response', response);
          if (response.data.code == 1) {
            this.yt.get();
            this.$message.success(this.$t('chenggong'));
            this.yt.isShowEditDialog = false;
            this.yt.editObj.loading = false;
          } else {
            this.$message.error(this.$t('shibai'));
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    //保存并排产
    getSchedulingAndGiveOut(row) {
      this.schedulingList = row;
      this.recommendEquipment = null;
      this.disabled1 = true;
      this.yt.editObj.loading = true;
      return this.http
        .post('/custom/weier/process/plan/schedulingAndGiveOutSilkScreen', {
          ...row
        })
        .then(response => {
          if (response.data.code == 1) {
            this.yt.get();
            this.$message.success(this.$t('chenggong'));
            this.yt.isShowEditDialog = false;
            this.yt.editObj.loading = false;
          } else {
            this.$message.error(this.$t('shibai'));
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
  }
};
</script>
